import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Box, useTheme, Button, useMediaQuery } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { tokens } from "../../theme";
import Header from "../../components/Header";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import config from "../../config";

const BranchList = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const colors = tokens(theme.palette.mode);
  const [selectedRow, setSelectedRow] = useState(null);
  const navigate = useNavigate();
  const [branchList, setBranchList] = useState([]);

  useEffect(() => {
    const fetchBranches = async () => {
      try {
        const response = await axios.get(`${config.apiBaseUrl}/get_branches`);
        console.log(response.data);
        setBranchList(response.data["branches"]);
      } catch (error) {
        console.error("Failed to fetch branches:", error);
        toast.error("Failed to fetch branches");
      }
    };

    fetchBranches();
  }, []);


  const columns = [
    {
      field: "branch_name",
      headerName: "Branch Name",
      flex: 1,
      minWidth: 220,
      cellClassName: "name-column--cell",
    },
    {
      field: "branch_code",
      headerName: "Branch Code",
      flex: 1,
      minWidth: 180,
    },
  ];

  const handleSelectionChange = (newSelection) => {
    setSelectedRow(newSelection.length === 1 ? newSelection[0] : null);
    console.log(selectedRow);
  };

  const handleUpdate = () => {
    if (selectedRow) {
      console.log("Selected Row ", selectedRow);
      const selectBranch = branchList.find((branch) => branch.branch_id === selectedRow);
      console.log(selectBranch);
      navigate("/manage_branch", { state: { branch: selectBranch } });
    }
  }

  const handleDelete = async () => {
    if (selectedRow) {
      console.log("Selected Row ", selectedRow);
      const selectBranch = branchList.find((branch) => branch.branch_id === selectedRow);
      console.log(selectBranch);
      try {
        await axios.delete(`${config.apiBaseUrl}/delete_branch/${selectedRow}`, {
          headers: {
            Authorization: `Bearer ${document.cookie
              .split("; ")
              .find((row) => row.startsWith("teba_auth_token="))
              ?.split("=")[1]}`,
          },
        });
        toast.success("Branch deleted successfully");
        setBranchList(branchList.filter((branch) => branch.branch_id !== selectedRow));
        setSelectedRow(null);
      } catch (error) {
        console.error("Failed to delete branch:", error);
        toast.error("Failed to delete branch");
      }
    }
  }

  return (
    <Box m={{ xs: "12px", sm: "16px", md: "20px" }}>
      <ToastContainer />
      <Header title="Branch List" subtitle="Branch List" />
      {selectedRow && (
        <Box display="flex" justifyContent="flex-start" flexWrap="wrap" gap={1} mt={2}>
          <Button variant="contained" color="success" sx={{ mr: { xs: 0, sm: "10px" } }} onClick={handleUpdate} size={isMobile ? "small" : "medium"}>
            Update
          </Button>
          <Button variant="contained" color="error" sx={{ mr: { xs: 0, sm: "10px" } }} onClick={handleDelete} size={isMobile ? "small" : "medium"}>
            Delete
          </Button>
        </Box>
      )}
      <Box
        mt={{ xs: 2, sm: 2.5, md: 4 }}
        height={{ xs: "62vh", sm: "68vh", md: "75vh" }}
        minHeight={{ xs: 360, sm: 420, md: 480 }}
        sx={{
          overflowX: "auto",
          "& .MuiDataGrid-root": {
            border: "none",
            minWidth: 760,
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
            fontSize: { xs: "0.76rem", sm: "0.82rem", md: "0.875rem" },
          },
          "& .MuiDataGrid-columnHeaderTitle": {
            fontSize: { xs: "0.72rem", sm: "0.8rem", md: "0.875rem" },
            fontWeight: 700,
          },
          "& .name-column--cell": {
            color: colors.greenAccent[300],
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: colors.blueAccent[700],
            borderBottom: "none",
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: colors.primary[400],
          },
          "& .MuiDataGrid-footerContainer": {
            borderTop: "none",
            backgroundColor: colors.blueAccent[700],
          },
          "& .MuiCheckbox-root": {
            color: `${colors.greenAccent[200]} !important`,
          },
        }}
      >
        <DataGrid 
          checkboxSelection 
          rows={Array.isArray(branchList) ? branchList : []} 
          columns={columns} 
          rowHeight={isMobile ? 46 : 52}
          getRowId={(row) => row.branch_id}
          onRowSelectionModelChange={handleSelectionChange}/>
      </Box>
    </Box>
  );
};

export default BranchList;